import React, { useState, useEffect } from 'react'
import Classes from './styles/style.module.css'
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { usePreventScrolling } from '../../../Hooks/usePreventScrolling';
import { CloseIcon } from '../../../utils/Icons';

// Don't delete it.
// const [openNotifyPopup, setopenNotifyPopup] = useState(false);
// const handleOpenNotifyPopup = () => setopenNotifyPopup(true);
// const handleCloseNotifyPopup = () => setopenNotifyPopup(false);
// const handleSubmitNotify = () => {
// }
// <AnimatePresence exit="wait">
//     {!openNotifyPopup && (
//         <NotifyPopup
//             closePopup={handleOpenNotifyPopup}
//             submitPopup={handleSubmitNotify}
//             title="Are you sure you want to proceed without a membership?"
//             description={"Without a membership, you are charged a $9.99 fee per fill up."}
//             buttonText="Return"
//             icon="exclamation"
//         />
//     )}
// </AnimatePresence>

export default function NotifyPopup({ closePopup, submitPopup, title, description, buttonText, icon }) {
    const handleBgClick = () => {
        closePopup();
    }

    const handleCardClick = (event) => {
        event.stopPropagation();
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        submitPopup();
    }

    usePreventScrolling();

    return (
        <>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                className={Classes.popup}
                onClick={handleBgClick}
            >
                <motion.div
                    initial={{ y: 7 }}
                    animate={{ y: 0 }}
                    exit={{ y: 7 }}
                    transition={{ duration: 0.25 }}
                    className={Classes.card}
                    onClick={(event) => { handleCardClick(event) }}
                >
                    <div className={Classes.close} onClick={closePopup} >
                        <CloseIcon height='20px' fill='white' />
                    </div>
                    <div className={Classes.bgPopup} >
                        <div></div>
                        {icon}
                        <div className={Classes.curveCon} >

                        </div>
                    </div>
                    <form onSubmit={handleSubmit} >
                        <div className={Classes.cardCon} >
                            <h5 className={Classes.title} >{title}</h5>
                            <h5 className={`${Classes.text2}`} >
                                {description}
                            </h5>
                            <div className={Classes.flexAlign} >
                                <button type="button" onClick={closePopup} className={Classes.btn1}>
                                    <h5> Cancel </h5>
                                </button>
                                <button type="button" onClick={handleSubmit} className={Classes.btn2}>
                                    <h5> {buttonText} </h5>
                                </button>
                            </div>
                        </div>
                    </form>
                </motion.div>
            </motion.div>
        </>
    )
}
